onDomReady(() => {
   TeardownPage.initialize();
});

const TeardownPage = {
   initialize: function () {
      this.filterOptions = $$('.filter-option');
      this.sortOptions = $$('#teardownSortOptions li a');

      // Were we invoked via the /Featured URL? If so, this is a featured
      // guides page, so we should set the base URL appropriately for rewriting
      // links.
      let invokedURI = new URI(document.location.href);
      let invokedPath = invokedURI.get('directory') + invokedURI.get('file');
      if (invokedPath.length <= 0) {
         // Invoked from the root domain, so we *probably* want to roll with
         // the /Featured base URL.
         this.baseURL = '/Featured';
      } else {
         // Trim off any trailing slash.
         this.baseURL =
            invokedPath.slice(Math.max(0, invokedPath.length - 1)) === '/'
               ? invokedPath.slice(0, Math.max(0, invokedPath.length - 1))
               : invokedPath;
      }

      // Set the base state based on the markup rendered on page load.
      let blurbsPagination = $('blurbsPagination');
      let teardownSortOptions = $('teardownSortOptions');
      let teardownFilterOptions = $E('.filter-items');
      this.curPage = blurbsPagination ? blurbsPagination.get('data-curPage').toInt() : 1;
      this.maxPage = blurbsPagination ? blurbsPagination.get('data-maxPage').toInt() : 0;
      this.sortBy = teardownSortOptions ? teardownSortOptions.get('data-sortBy') : 'recent';
      this.filterBy = teardownFilterOptions ? teardownFilterOptions.get('data-filterBy') : 'all';

      this.filterOptions.each(function (option) {
         option.addEvents({
            mouseenter: this.activateButton.pass(option),
            mouseleave: this.deactivateButton.pass(option),
            click: this.toggleFilterOption.bind(this, option),
         });

         let filterName = option.getElement('span').get('text');
         option.store('filterName', filterName);
         if (filterName == this.filterBy) {
            option.addClass('filter-option-active');
         }
      }, this);

      this.sortOptions.each(function (option) {
         option.addEvents({
            click: this.toggleSortOption.bind(this, option),
         });

         let sortName = option.get('id').split('_', 2)[1];
         option.store('sortName', sortName);
         if (sortName == this.sortBy) {
            option.addClass('active');
         }
      }, this);

      // The window's 'popstate' event is fired when a state is changed by
      // forward/back events. When the event is fired the new location is
      // already active. MooTools's addEvent method doesn't work with this
      // event.
      window.onpopstate = this.historyStateChange.bind(this);

      // Store the initial page data with the current history state, so that we
      // can recover it on back/forward navigation events without making a new
      // request.
      let state = { html: $('teardownBlurbs').get('html') };
      history.replaceState(state, null, window.location.toString());

      this.addPaginateEvents();
      this.rewriteLinks();
      this.hideDuplicateHeaders();

      $('blurbsSpinner').set('src', window.shared_constants.BaseURI('SITE_IMAGE_BLANK'));
   },

   // For Featured Student page: hide the second "Popular Guides" header.
   hideDuplicateHeaders: function () {
      let headers = $$('.popular-blurbs h3');

      if (headers.length == 2 && headers[0].innerHTML == headers[1].innerHTML) {
         headers[1].addClass('duplicate-header');
      }
   },

   // Make sure the visual sort and filter buttons are in sync with our state.
   updateSortsAndFilters: function () {
      this.sortOptions.invoke('removeClass', 'active');
      this.sortOptions.each(option => {
         if (option.retrieve('sortName') == this.sortBy) {
            option.addClass('active');
         }
      });

      this.filterOptions.invoke('removeClass', 'filter-option-active');
      this.filterOptions.each(option => {
         if (option.retrieve('filterName') == this.filterBy) {
            option.addClass('filter-option-active');
         }
      });
   },

   // Called when the user initiates a back/forard event; updates the internal
   // state from the navigated-to URI and rebuilds the list of teardowns. If
   // we've previously stored data (the blurb HTML) for this state, use that to
   // update the UI, avoiding another request.
   historyStateChange: function (ev) {
      let args = new URI(window.location).getData();

      this.curPage = args.page ? args.page.toInt() : 1;
      this.sortBy = args.sort || 'recent';
      this.filterBy = args.filter || 'all';

      this.updateTeardowns(ev.state);
   },

   // Call a function that updates the internal state in the context of 'this',
   // then make a request for the new list of teardown blurbs. Store the
   // response with the new browser state so that if the user navigates back to
   // that state in the same browser, we can reuse the data without making a
   // new request.
   updateState: function (makeChange) {
      makeChange.apply(this);
      this.updateTeardowns(null, function (response) {
         history.pushState(response, '', this.makeStateURL());
      });
   },

   // Build a URI for the internal state, optionally modified by the passed-in
   // state object, which should only contain the same property names that we
   // use to store state in 'this'. The modified state isn't kept; it's just
   // used to build a URL string.
   makeStateURL: function (state) {
      state = Object.merge(
         {
            page: this.curPage,
            sort: this.sortBy,
            filter: this.filterBy,
         },
         state || {}
      );
      let url = new URI(this.baseURL);
      return url.setData(state).toString();
   },

   addPaginateEvents: function () {
      let nextPage = $('nextPage');
      let prevPage = $('prevPage');

      if (nextPage) {
         nextPage.addEvent('click', ev => {
            ev.stop();
            this.updateState(function () {
               this.curPage++;
            });
         });
      }

      if (prevPage) {
         prevPage.addEvent('click', ev => {
            ev.stop();
            this.updateState(function () {
               this.curPage--;
            });
         });
      }
   },

   rewriteLinks: function () {
      let nextPage = $('nextPage');
      let prevPage = $('prevPage');
      let nextPageTop = $('nextPageTop');

      if (nextPage) {
         nextPage.set('href', this.makeStateURL({ page: this.curPage + 1 }));
      }

      if (prevPage) {
         prevPage.set('href', this.makeStateURL({ page: this.curPage - 1 }));
      }

      if (nextPageTop) {
         nextPageTop.set('href', this.makeStateURL({ page: this.curPage + 1 }));
      }

      this.sortOptions.each(function (option) {
         option.set(
            'href',
            this.makeStateURL({
               sort: option.retrieve('sortName'),
            })
         );
      }, this);
   },

   activateButton: function (btn) {
      btn.addClass('activeButton');
   },

   deactivateButton: function (btn) {
      btn.removeClass('activeButton');
   },

   toggleFilterOption: function (option) {
      if (option.hasClass('filter-option-active')) {
         return;
      } else {
         this.updateState(function () {
            this.filterBy = option.retrieve('filterName');
            this.curPage = 1;
            this.filterOptions.invoke('removeClass', 'filter-option-active');
            option.addClass('filter-option-active');
         });
      }
   },

   toggleSortOption: function (option, ev) {
      ev.stop();

      if (option.hasClass('active')) {
         return;
      }

      this.updateState(function () {
         this.sortBy = option.retrieve('sortName');
         this.filterBy = 'all';
         this.curPage = 1;
         this.sortOptions.invoke('removeClass', 'active');
         option.addClass('active');
      });
   },

   updateTeardowns: function (savedState, cb) {
      let langid = $('teardownBlurbs').dataset.langid;
      $('blurbsSpinner').set('src', window.shared_constants.BaseURI('SITE_IMAGE_BLURBS_LOADING'));

      if (savedState) {
         this.applyUpdate(savedState);
      } else {
         new Request.AjaxIO('updatePaginatedBlurbs', {
            onSuccess: function (response) {
               this.applyUpdate(response);
               if (cb) {
                  cb.call(this, response);
               }
            }.bind(this),
         }).send({
            filter: this.filterBy,
            sortBy: this.sortBy,
            page: this.curPage,
            langid: langid,
         });
      }

      this.updateSortsAndFilters();
   },

   applyUpdate: function (response) {
      $('teardownBlurbs').set('html', response.html);

      let blurbsPagination = $('blurbsPagination');
      this.maxPage = blurbsPagination ? blurbsPagination.get('data-maxPage').toInt() : 0;

      this.addPaginateEvents();
      this.rewriteLinks();

      $('blurbsSpinner').set('src', window.shared_constants.BaseURI('SITE_IMAGE_BLANK'));
   },
};
